import { FC, PropsWithChildren } from "react";
import { useSelector } from "react-redux";

import { RootState } from "@/utils/store";

const HideElements: FC<PropsWithChildren> = ({ children }) => {
  const userEmail = useSelector((state: RootState) => state.auth.user?.email);

  if (userEmail !== "bps.backbone.testing@gmail.com") {
    return <>{children}</>;
  }
  return null;
};

export default HideElements;
